enum ODDS_FORMAT {
	DECIMAL = 'decimal',
	AMERICAN = 'american',
	FRACTIONAL = 'fractional',
}

export default ODDS_FORMAT;
